import { ExportPayloadSection } from '../types';

const countTotalRows = (sections: ExportPayloadSection[]): number => {
  let total = 0;
  for (const section of sections) {
    total += section.rows.length;
    for (const childSection of section.childSections ?? []) {
      childSection.rowsByMasterId.forEach((childRows) => {
        total += childRows.length;
      });
    }
  }
  return total;
};

export default countTotalRows;
